/* ===================================================
   Eube Video Slider — section-video-slider.js  v10
   Assets/section-video-slider.js
   =================================================== */

(function () {
  'use strict';

  /* ----------------------------------------
     Shared helpers
  ---------------------------------------- */

  function updatePlayBtn(card, playing) {
    var p = card.querySelector('.icon-play');
    var u = card.querySelector('.icon-pause');
    if (!p || !u) return;
    p.style.display = playing ? 'none'  : 'block';
    u.style.display = playing ? 'block' : 'none';
  }

  function updateMuteBtn(card, muted) {
    var off = card.querySelector('.icon-sound-off');
    var on  = card.querySelector('.icon-sound-on');
    if (!off || !on) return;
    off.style.display = muted ? 'block' : 'none';
    on.style.display  = muted ? 'none'  : 'block';
  }

  function wireControls(card) {
    var video = card.querySelector('.vs-video');
    if (!video) return;
    video.muted = true;
    updateMuteBtn(card, true);

    var playBtn = card.querySelector('.vs-btn--play');
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) { video.play().catch(function(){}); updatePlayBtn(card, true);  }
        else              { video.pause();                    updatePlayBtn(card, false); }
      });
    }

    var muteBtn = card.querySelector('.vs-btn--mute');
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        updateMuteBtn(card, video.muted);
      });
    }

    video.addEventListener('play',  function () { updatePlayBtn(card, true);  });
    video.addEventListener('pause', function () { updatePlayBtn(card, false); });
  }

  function pauseAll(cards) {
    cards.forEach(function (c) {
      var v = c.querySelector('.vs-video');
      if (v && !v.paused) { v.pause(); updatePlayBtn(c, false); }
    });
  }

  function playOne(card) {
    if (!card) return;
    var v = card.querySelector('.vs-video');
    if (v) { v.play().catch(function(){}); updatePlayBtn(card, true); }
  }

  function wrap(idx, total) {
    return ((idx % total) + total) % total;
  }

  /* ================================================
     DESKTOP FAN — 5 slots, circular, arrows at edges
  ================================================ */

  var DESK_ALL  = ['pos-hidden','pos-far-left','pos-mid-left','pos-center','pos-mid-right','pos-far-right'];
  var DESK_SLOT = { '-2':'pos-far-left', '-1':'pos-mid-left', '0':'pos-center', '1':'pos-mid-right', '2':'pos-far-right' };

  function setupDesktopFan(section) {
    var fan     = section.querySelector('.vs-fan');
    var prevBtn = section.querySelector('.vs-arrow--prev');
    var nextBtn = section.querySelector('.vs-arrow--next');
    if (!fan) return;

    var cards = Array.from(fan.querySelectorAll('.vs-card'));
    var total = cards.length;
    if (total === 0) return;

    cards.forEach(wireControls);

    var centerIdx = 0;

    if (prevBtn) prevBtn.style.display = total > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = total > 1 ? '' : 'none';

    function render(instant) {
      cards.forEach(function (card, i) {
        var slot = i - centerIdx;
        if (slot >  Math.floor(total / 2)) slot -= total;
        if (slot < -Math.floor(total / 2)) slot += total;
        var cls = (Math.abs(slot) <= 2) ? (DESK_SLOT[String(slot)] || 'pos-hidden') : 'pos-hidden';
        DESK_ALL.forEach(function (c) { card.classList.remove(c); });
        card.classList.add(cls);
        card.style.transition = instant ? 'none' : '';
      });
      pauseAll(cards);
      playOne(cards[centerIdx]);
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { centerIdx = wrap(centerIdx - 1, total); render(false); });
    if (nextBtn) nextBtn.addEventListener('click', function () { centerIdx = wrap(centerIdx + 1, total); render(false); });

    /* Autoplay center on scroll */
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = cards[centerIdx] && cards[centerIdx].querySelector('.vs-video');
        if (!v) return;
        if (e.isIntersecting) { v.play().catch(function(){}); updatePlayBtn(cards[centerIdx], true); }
        else                  { v.pause(); updatePlayBtn(cards[centerIdx], false); }
      });
    }, { threshold: 0.35 }).observe(section);

    render(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cards.forEach(function (c) { c.style.transition = ''; });
      });
    });
  }

  /* ================================================
     MOBILE FAN — 3 slots (mob-left, mob-center, mob-right)
     Identical pattern to desktop, just fewer slots.
     Position classes: mob-hidden, mob-left, mob-center, mob-right
  ================================================ */

  var MOB_ALL  = ['mob-hidden', 'mob-left', 'mob-center', 'mob-right'];
  var MOB_SLOT = { '-1': 'mob-left', '0': 'mob-center', '1': 'mob-right' };

  function setupMobileFan(section) {
    var fan     = section.querySelector('.vs-mob-fan');
    var prevBtn = section.querySelector('.vs-mob-arrow--prev');
    var nextBtn = section.querySelector('.vs-mob-arrow--next');
    if (!fan) return;

    var cards = Array.from(fan.querySelectorAll('.vs-mob-card'));
    var total = cards.length;
    if (total === 0) return;

    cards.forEach(wireControls);

    var centerIdx = 0;

    if (prevBtn) prevBtn.style.display = total > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = total > 1 ? '' : 'none';

    function render(instant) {
      cards.forEach(function (card, i) {
        var slot = i - centerIdx;
        /* Circular: find shortest path */
        if (slot >  Math.floor(total / 2)) slot -= total;
        if (slot < -Math.floor(total / 2)) slot += total;
        /* Slot -1=left, 0=center, 1=right, anything else=hidden */
        var cls = MOB_SLOT[String(slot)] || 'mob-hidden';
        MOB_ALL.forEach(function (c) { card.classList.remove(c); });
        card.classList.add(cls);
        card.style.transition = instant ? 'none' : '';
      });

      pauseAll(cards);
      playOne(cards[centerIdx]);

      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { centerIdx = wrap(centerIdx - 1, total); render(false); });
    if (nextBtn) nextBtn.addEventListener('click', function () { centerIdx = wrap(centerIdx + 1, total); render(false); });

    /* Swipe */
    var touchStartX = null;
    fan.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    fan.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var d = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(d) > 40) { centerIdx = wrap(centerIdx + (d > 0 ? 1 : -1), total); render(true); }
      touchStartX = null;
    }, { passive: true });

    /* Autoplay center on scroll */
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = cards[centerIdx] && cards[centerIdx].querySelector('.vs-video');
        if (!v) return;
        if (e.isIntersecting) { v.play().catch(function(){}); updatePlayBtn(cards[centerIdx], true); }
        else                  { v.pause(); updatePlayBtn(cards[centerIdx], false); }
      });
    }, { threshold: 0.3 }).observe(section);

    /* Initial render — instant, then re-enable transitions */
    render(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cards.forEach(function (c) { c.style.transition = ''; });
      });
    });
  }

  /* ================================================
     Init
  ================================================ */

  function init(section) {
    setupDesktopFan(section);
    setupMobileFan(section);
  }

  function boot() {
    document.querySelectorAll('.video-slider-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.video-slider-section');
    if (s) init(s);
  });

}());
